const packageJson = require("../../package.json");

const enviroment = {
  urlApi:  process.env.REACT_APP_URL_API,
  version: packageJson.version,
};

export default enviroment;
